import { PageDefaultSegmentWithHeader, useMountEffect } from "@sis/react-library"
import { AdminFunctionsPageAreaProps } from "../adminFunctionsPage/AdminFunctionsPage"
import { commonState } from "../../../redux/common/commonSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Provider } from "../../../interfaces/dtos/common";
import { categoryItems } from "../../shared/sharedHelper";
import { useState } from "react";
import { Alert, Box, Button, LinearProgress, Stack, useTheme } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { trackState } from "../../../redux/track/trackSlice";
import { saveTrack } from "../../../redux/track/trackAction";

export const AdminFunctionsResaveAllTracksArea = ({
    onClose
}: AdminFunctionsPageAreaProps) => {

    const common = useAppSelector(commonState);
    const tracks = useAppSelector(trackState);
    const dispatch = useAppDispatch();
    const theme = useTheme();

    const [inProgressText, setInProgressText] = useState("");
    const [inProgressValue, setInProgressValue] = useState(0);
    const [itemsCompleted, setItemsCompleted] = useState<string[]>([]);
    const [completed, setCompleted] = useState(false);
    const [busyExecuting, setBusyExecuting] = useState(false);

    const executeResaveAllTracks = async () => {
        if (busyExecuting || completed) { return; }
        setBusyExecuting(true);
        for (const provider of common.providers) {
            await saveAllForProvider(provider);
        }
        setBusyExecuting(false);
        setCompleted(true);
    }

    const saveAllForProvider = async (provider: Provider) => {
        //categoryItems
        for (const categoryItem of categoryItems) {
            await saveAllForProviderCategory(provider, categoryItem);
        }
    }

    const saveAllForProviderCategory = async (provider: Provider, categoryItem: { key: string, value: string }) => {
        setInProgressText(`Re-saving tracks: ${provider.description} - ${categoryItem.value}`);

        const tracksToUpdate = tracks.tracks.filter(t => t.provider === provider.code && t.categoryCode === categoryItem.key);
        setInProgressValue(0);
        let i = 0;
        for (const track of tracksToUpdate) {
            i++;
            setInProgressValue(i / tracksToUpdate.length * 100);
            await dispatch(saveTrack(track));
        }

        const newItemsCompleted = itemsCompleted;
        newItemsCompleted.push(`Re-saved tracks: ${provider.description} - ${categoryItem.value}`);
        setItemsCompleted(newItemsCompleted);
    }

    useMountEffect(() => {
        executeResaveAllTracks();
    })

    return (
        <PageDefaultSegmentWithHeader headingText="Resaving All Tracks" id="area-resave-all-tracks">
            <Stack>
                {itemsCompleted.map((ic) => (
                    <Box key={`${ic}`} sx={{ padding: 1 }}>
                        <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                            {ic}
                        </Alert>
                    </Box>
                ))}
                {!completed &&
                    <Box sx={{ padding: 1 }}>
                        <Box sx={{ color: theme.palette.secondary.main }}>{inProgressText}</Box>
                        {inProgressValue !== 0 &&
                            <LinearProgress
                                key={inProgressText}
                                sx={{ marginTop: 2 }}
                                variant="determinate" value={inProgressValue}
                            />
                        }
                    </Box>
                }
                {completed &&
                    <Box sx={{ paddingTop: 2 }}>
                        <Button
                            variant="contained"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </Box>
                }
            </Stack>
        </PageDefaultSegmentWithHeader >
    )
}
